export default function CtaBand() {
  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-500 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-400/50 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-20 left-1/3 h-56 w-56 rounded-full bg-accent-500/25 blur-3xl"></div>

          <div className="relative flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-compass-3-line text-sm"></i>
                还是没找到？
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                搜索没命中的分类，多半藏在标签目录里
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-background-50/90 md:text-base">
                栏目给的是大方向，专题给的是完整脉络，真正细碎的入口都沉在标签里。
                先看一遍「使用说明」，能少走不少弯路。
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
              <a
                href="#tags"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
              >
                <i className="ri-price-tag-3-line text-base"></i>
                浏览标签目录
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/50 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-question-line text-base"></i>
                查看使用说明
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}